import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Education.scss";
import images from "../../constants/images";
// import education from "../../../../backend_sanity/schemas/education";

const Education = () => {
  const [educations, setEducations] = useState([]);

  useEffect(() => {
    const query = '*[_type == "education"]';

    client.fetch(query).then((data) => {
      setEducations(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">
        My <span>Educational</span> Background Section
      </h2>
      <div
        className="edu__profiles"
        style={{ backgroundImage: `url(${images.unbPortrait})` }}
      >
        {educations.map((education, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="edu__profile-item"
            key={education.title + index}
          >
            <img
              src={urlFor(education.school_imageurl)}
              alt={education.title}
            />
            <div className="education_cont">
              <h2 className="bold-text" style={{ marginTop: 20 }}>
                {education.program_name}
              </h2>
              <p className="p-text" style={{ marginTop: 10 }}>
                {education.school_name}
              </p>
              <p className="p-text" style={{ marginTop: 8 }}>
                {education.duration_span}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Education, "app__education"),
  "education",
  "app__primarybg"
);
